import useSWR, { type SWRConfiguration } from 'swr'
import {
  type NshiftDeliveryOptionsRequestFE,
  type NshiftDeliveryOptionsResponse,
  type NshiftUpdateSessionRequestFE,
  type NshiftUpdateSessionResponseFE
} from 'ecosystem'
import fetchJson from 'api/utils/next/fetchJson'
import useSWRMutation from 'swr/mutation'

export const useNshiftGetDeliveryOptions = (
  payload: NshiftDeliveryOptionsRequestFE,
  params?: { skip?: boolean; config?: SWRConfiguration<NshiftDeliveryOptionsResponse, Error> }
) => {
  return useSWR<NshiftDeliveryOptionsResponse>(
    params?.skip ? null : ['/api/nshift/delivery-options', payload],
    ([url, args]) =>
      fetchJson(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(args as NshiftDeliveryOptionsRequestFE)
      }),
    params?.config
  )
}

export const useNshiftUpdateSessionMutation = () => {
  return useSWRMutation<NshiftUpdateSessionResponseFE, Error, string, NshiftUpdateSessionRequestFE>(
    '/api/nshift/update-session',
    (url, { arg }) =>
      fetchJson<NshiftUpdateSessionResponseFE>(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(arg)
      })
  )
}
